import { createApp } from 'vue';
import Loading from '@/library/Loading.vue';

let loadingInstance = null;
let activeRequests = 0;
let hideTimer = null;

// 初始化 loading 元素
const initLoading = () => {
  if (!loadingInstance) {
    // 創建一個專門用於 loading 的 div 容器
    const loadingContainer = document.createElement('div');
    loadingContainer.id = 'loading-container';
    document.body.appendChild(loadingContainer);

    // 創建 Vue 應用實例，並掛載到容器上
    loadingInstance = createApp(Loading).mount(loadingContainer);

    // 初始化時默認隱藏
    loadingContainer.style.display = 'none';
  }
};

// 當文檔加載完成後初始化 loading 元素
document.addEventListener('DOMContentLoaded', initLoading);

// 顯示 loading
const showLoading = () => {
  initLoading(); // 確保已初始化
  const container = document.getElementById('loading-container');
  if (container && container.style.display === 'none') {
    // 清除可能的隱藏計時器
    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
    // 顯示 loading
    container.style.display = 'block';
  }
};

// 隱藏 loading (帶延遲)
const hideLoading = () => {
  const container = document.getElementById('loading-container');
  if (container && container.style.display !== 'none') {
    // 設置延遲隱藏，如果已有計時器則清除後重設
    if (hideTimer) {
      clearTimeout(hideTimer);
    }

    hideTimer = setTimeout(() => {
      // 只有當確實沒有活動請求時才隱藏
      if (activeRequests === 0) {
        container.style.display = 'none';
      }
      hideTimer = null;
    }, 50);
  }
};

// 主要的 loading 控制函數
const useLoading = (status) => {
  if (status) {
    activeRequests++;
    if (activeRequests === 1) {
      showLoading();
    }
  } else {
    if (activeRequests > 0) {
      activeRequests--;
    }

    if (activeRequests === 0) {
      hideLoading();
    }
  }
};

export default useLoading;
